import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import JuegosView from './JuegosView';

const JuegosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.juegos}
      routes={[ROUTES.juegosDeportivos]}
    >
      <JuegosView />
    </ContainerTemplate>
  );
};

export default JuegosModule;
